<template>
    <q-no-ssr>
        <div class="row container-global" style="padding-top : 98px">
            <div class="col-12 col-md-3">
                <div class="box-type-helpers q-ma-md q-pa-sm">
                    <div class="cursor-pointer  fs-md " @click="changeBox(1)" :class="{ 'active': boxShow == 1 }">
                        المقدمـة</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(2)" :class="{ 'active': boxShow == 2 }">
                        التعاريف</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(3)" :class="{ 'active': boxShow == 3 }">نطاق
                        التطبيق</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(4)" :class="{ 'active': boxShow == 4 }">مجالات
                        التقييم المعتمدة</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(5)" :class="{ 'active': boxShow == 5 }">الأدوار
                        والمسؤوليات</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(6)" :class="{ 'active': boxShow == 6 }">دورة
                        حياة الطلب</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(7)" :class="{ 'active': boxShow == 7 }">
                        المعايير وآلية التقييم</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(8)" :class="{ 'active': boxShow == 8 }">شروط
                        الاعتماد ومراحله</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(9)" :class="{ 'active': boxShow == 9 }">صلاحية
                        الاعتماد</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(10)" :class="{ 'active': boxShow == 10 }">
                        ملاحظات إضافية</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(11)" :class="{ 'active': boxShow == 11 }">
                        الخصوصية والسرية</div>
                    <div class="cursor-pointer  fs-md" @click="changeBox(12)" :class="{ 'active': boxShow == 12 }">تحديث
                        المنهجية</div>
                </div>
            </div>
            <div class="col-12 col-md-9">
                <div class="box-content-helpers q-ma-md q-pa-md">
                    <div class="q-pa-sm q-mb-xl" :data-box="1">
                        <h3 class="title">
                            المقدمـة
                        </h3>
                        <p class="desc">
                            تهدف هذه المنهجية إلى تنظيم وتشغيل آلية استقبال وتنفيذ التقييمات الرقمية من خلال نظام
                            إلكتروني متكامل، يضمن دقة التنفيذ وعدالة التوزيع وجودة المخرجات، بما يدعم اتـــــــــــخاذ
                            القرار
                            وتحسين جودة المنتجات والخدمات الرقمية.
                        </p>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="2">
                        <h3 class="title">
                            التعاريف
                        </h3>

                        <div class="methodology-table">
                            <div class="table-header">
                                <div class="table-header-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="header-text"> المصطلح</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-header-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="header-text">التعريف</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">الطلب</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">عملية تقديم خدمة التقييم عبر النظام من خلال
                                                الموقع</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">المراجع</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">المسؤول عن مراجعة الطلبات الجديدة وتحديد صلاحيتها
                                                للتوزيع.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">المقيم</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">مستخدم معتمد يقوم بتنفيذ التقييمات ضمن مجاله
                                                التخصصي.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">المدقق</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">مسؤول الجودة الذي يراجع التقييمات قبل
                                                اعتمادها.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">حالة الطلب</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">الوضع الذي يمر به الطلب داخل النظام (قيد المراجعة،
                                                قيد التنفيذ، مكتمل...).</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">التخصص</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">المجال المعرفي الذي يُسند بناءً عليه الطلب للمقيّمين
                                                المناسبين.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="3">
                        <h3 class="title">
                            نطاق التطبيق
                        </h3>
                        <p class="desc">
                            تُطبق هذه المنهجية على كافة الطلبات الواردة من موقع المنصة والمتعلقة بتقييـــــم :
                        </p>
                        <ul>
                            <li>مواقع إلكترونية</li>
                            <li>منتجات رقمية</li>
                            <li>تطبيقات وخدمات حكومية أو تجارية</li>
                        </ul>
                        <p class="desc">
                            وتغطي مراحل الطلب من الاستقبال وحتى عرض النتائج للعمـــــيل.
                        </p>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="4">
                        <h3 class="title">
                            مجالات التقييم المعتمدة
                        </h3>
                        <div class="methodology-table">
                            <div class="table-header">
                                <div class="table-header-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="header-text">التخصص</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-header-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="header-text">وصف موجز</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">التجربة الرقمية (Digital Experience)</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">تقييم شامل لرحلة المستخدم الرقمية، وقياس مدى سلاسة
                                                الأداء عبر القنوات والمنصات المختلفة.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">تجربة المستخدم (UX)</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">تحليل سلوك وتفاعل المستخدم مع المنتج أو الخدمة
                                                الرقمية، بهدف الكشف عن العقبات وتحسين التفاعل.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">تصميم واجهة المستخدم (UI)</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">تقييم العناصر البصرية (ألوان، خطوط، أزرار، تخطيط...)
                                                ومدى توافقها مع معايير التصميم الجيد.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">سهولة الوصول (Accessibility)</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">التأكد من قدرة ذوي الإعاقة على استخدام المنصة أو
                                                الخدمة وفق معايير النفاذ الرقمي (WCAG...).</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">كتابة المحتوى وجودته</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">مراجعة النصوص من حيث الوضوح، الأسلوب، اللغة،
                                                الاتساق، والتنقل السلس داخل المحتوى.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">تحسين محركات البحث (SEO)</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">قياس مدى توافق الموقع مع متطلبات محركات البحث من حيث
                                                البنية والكلمات المفتاحية والتقنيات.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">الأمن السيبراني</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">فحص عام للممارسات الأمنية الظاهرة في الواجهة مثل
                                                حماية البيانات، الروابط، وإعدادات الخصوصية.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">دعم اللغات وجودة الترجمة</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">مراجعة دعم اللغة العربية أو لغات أخرى من حيث الترجمة،
                                                الصياغة، التنسيق، واتساق الرسائل.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="5">
                        <h3 class="title">
                            الأدوار والمسؤوليات
                        </h3>
                        <div class="methodology-table">
                            <div class="table-header">
                                <div class="table-header-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="header-text">الدور</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-header-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="header-text">المهام</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">مقدم الطلب</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">تقديم الطلب عبر الموقع مع تحديد نوع التقييم والخدمة
                                                المستهدفة.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">المراجع</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">مراجعة الطلب والموافقة عليه أو رفضه بناءً على المعايير
                                                المحددة.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">المقيم</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">تنفيذ التقييم وفق المعايير المحددة وإرفاق الملاحظات
                                                والأدلة.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row alt-bg">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">المدقق</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">مراجعة مخرجات المقيمين وضمان دقة النتائج وجودة التقرير
                                                النهائي.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="table-row">
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="cell-text">إدارة النظام</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-row-cell">
                                    <div class="cell-content">
                                        <div class="text-wrapper">
                                            <span class="link-text">الإشراف العام، إدارة الحسابات، متابعة الأداء، وتحديث
                                                المعايير.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="6">
                        <h3 class="title">
                            دورة حياة الطلب
                        </h3>
                        <ol class="lifecycle-list">
                            <li>
                                <strong>تقديم الطلب:</strong> يتم عبر الموقع، ويشمل اختيار نوع التقييم وإدخال البيانات
                                المطلوبة.
                            </li>
                            <li>
                                <strong>مراجعة الطلب:</strong>
                                <ul>
                                    <li>يتحقق من اكتمال الطلب وصحته.</li>
                                    <li>في حال الموافقة، ينتقل إلى مرحلة التوزيع.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>دعوة المقيمين للمشاركة:</strong>
                                <ul>
                                    <li>يظهر للمقيّمين المؤهلين حسب التخصص</li>
                                    <li>يتم حذف الدعوات بعد اكتمال العدد المطلوب من المقيمين.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>تنفيذ التقييم:</strong>
                                <ul>
                                    <li>يقوم المقيمون بتنفيذ المهام وتوثيق النتائج.</li>
                                    <li>النظام يمنع الإرسال ما لم تُعبأ جميع الحقول المطلوبة.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>تدقيق النتائج:</strong>
                                <ul>
                                    <li>يتحقق المدقق من جودة التقييم.</li>
                                    <li>يمكن إعادة التقييم لأحد المقيمين إذا وُجدت ملاحظات.</li>
                                </ul>
                            </li>
                            <li>
                                <strong>تسليم المشروع:</strong> بعد التدقيق يتم اشعار مقدم الطلب باكتماله، ويلزم الموافقة
                                حتى يتمكن من رؤية النتائج.
                            </li>
                            <li>
                                <strong>اعتماد النتائج:</strong>
                                <ul>
                                    <li>بعد استلام الطلب من قبل مقدم الطلب تعرض النتائج للعميل داخل الأداة والموقع.</li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="7">
                        <h3 class="title">
                            المعايير وآلية التقييم
                        </h3>
                        <p class="desc">
                                يُشترط على المقيم المعتمد تقديم ملاحظات مهنية، محايدة، ومستندة إلى خبرته وتخصصه، مع
                                الالتزام بالاستخدام الفعلي للموقع أو الخدمة محل التقييم.
                            </p>
                            <p class="desc">
                                ويُمنع تضمين أي ملاحظات صورية أو غير دقيقة، أو إعادة استخدام ملاحظات سابقة دون مراجعة أو
                                تعديل يتوافق مع متطلبات التقييم الحالي.
                            </p>
                            <p class="desc">
                                تُقدَّم الملاحظات من خلال:
                            </p>
                            <ul class="content-list">
                                <li>تحديد مواضع التحسين داخل الواجهة أو الخدمة.</li>
                                <li>كتابة ملاحظات وصفية واضحة تعكس التحديات أو المشكلات المكتشفة.</li>
                            </ul>
                            <h4 class="subtitle">مراعاة شروط قبول التقييم</h4>
                            <ol class="content-list numbered">
                                <li>توضيح المشكلة والسبب مع ربطها بمبادئ التخصص.</li>
                                <li>تحديد مستوى الخطورة (عالية – متوسطة – منخفضة)</li>
                                <li>اقتراح حل عملي مباشر قابل للتنفيذ.</li>
                                <li>إضافة مثال ناجح عند الإمكان لدعم التوصية.</li>
                            </ol>
                            <p class="desc">
                                تخضع جميع التقييمات للتدقيق قبل اعتمادها، وفي حال رُصدت مخالفات مثل:
                            </p>
                            <ul class="content-list">
                                <li>التقييم دون استخدام فعلي،</li>
                                <li>المجاملة أو التحيز غير المبرر،</li>
                                <li>وجود تلاعب أو افتعال نتائج غير حقيقية؛</li>
                            </ul>
                            <p class="desc">
                                فستُتخذ الإجراءات التالية:
                            </p>
                            <ul class="content-list">
                                <li>حذف التقييم مباشرة،</li>
                                <li>تسجيل المخالفة في سجل المقيّم.</li>
                                <li>استبعاد المقيّم من المهام المستقبلية في حال تكرار المخالفة.</li>
                            </ul>
                            <h4 class="subtitle">ضمان الجودة</h4>
                            <ul class="content-list">
                                <li>مراجعة داخلية لكل طلب قبل الاعتماد النهائي.</li>
                                <li>توثيق كل مرحلة بالتاريخ والوقت وهوية المنفّذ.</li>
                                <li>النظام يحتفظ بسجل كامل للطلبات والتعديلات.</li>
                                <li>المدققين يتحققون من:
                                    <ul class="content-list nested">
                                        <li>الاتساق بين التقييمات</li>
                                        <li>التوثيق الكافي</li>
                                        <li>التزام المقيّم بالمعايير</li>
                                    </ul>
                                </li>
                            </ul>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="8">
                        <h3 class="title">
                            شروط الاعتماد ومراحله
                        </h3>
                            <p class="desc">
                                ضمان أن جميع المقيمين العاملين في النظام يمتلكون الحد الأدنى من التأهيل والخبرة، وقادرون
                                على تنفيذ التقييمات وفق المعايير المحددة وبجودة عالية، بما يضمن موثوقية المخرجات.
                            </p>
                            <div class="section-divider"></div>
                            <h5 class="subtitle">شروط الاعتماد</h5>
                            <p class="desc">
                                لا يُمنح المقيم صفة "مقيم معتمد" إلا بعد استيفاء جميع الشروط التالية:
                            </p>
                            <ol class="content-list numbered">
                                <li>التسجيل الكامل في النظام من خلال تعبئة نموذج التسجيل المخصص، متضمنًا:
                                    <ul class="content-list nested">
                                        <li>الاسم الكامل.</li>
                                        <li>نبذة مهنية مختصرة.</li>
                                        <li>رابط الملف الشخصي المهني مثل LinkedIn أو موقع شخصي</li>
                                        <li>اختيار التخصص المطلوب.</li>
                                        <li>الدولة، المنطقة، المدينة.</li>
                                        <li>المستوى التعليمي وسنوات الخبرة.</li>
                                        <li>اللغات التي يتقنها.</li>
                                        <li>تحميل الهوية أو وثيقة داعمة (اختياري).</li>
                                    </ul>
                                </li>
                                <li>تنفيذ عدد لا يقل عن (10) تقييمات فعلية داخل الأداة في نفس التخصص الذي يرغب المقيم
                                    في اعتماده.</li>
                                <li>مطابقة بيانات الحساب البنكي مع اسم المستخدم لضمان صحة التحويلات المالية
                                    المستقبلية.</li>
                                <li>الالتزام بسياسات المنصة بما في ذلك اتفاقية الاستخدام وسياسة الخصوصية واتفاقية عدم
                                    الإفصاح (NDA).</li>
                            </ol>
                            <div class="section-divider"></div>
                            <h5 class="subtitle">مراحل الاعتماد</h5>
                            <ol class="content-list numbered">
                                <li>تنفيذ التقييمات الأولية
                                    <ul class="content-list nested">
                                        <li>يجب على المقيم تنفيذ 10 تقييمات في التخصص المطلوب.</li>
                                        <li>تتم مراجعة هذه التقييمات من قبل المراجعين المختصين لضمان التزامها بالمعايير
                                            وجودة المخرجات.</li>
                                    </ul>
                                </li>
                                <li>تقديم طلب الاعتماد
                                    <ul class="content-list nested">
                                        <li>بعد استكمال التقييمات، يقوم المقيم بتقديم طلب رسمي للاعتماد من خلال النظام.
                                        </li>
                                    </ul>
                                </li>
                                <li>مراجعة طلب الاعتماد
                                    <ul class="content-list nested">
                                        <li>يراجع المراجع ملف المقيم والتقييمات المنفذة، ويتخذ أحد القرارين:
                                            <ul class="content-list nested">
                                                <li>القبول: يتم اعتماد المقيم رسميًا، ويُشعر بذلك عبر النظام.</li>
                                                <li>الرفض: يُشعر المقيم بالأسباب حسب الإمكانية ويُمنح فرصة لإعادة التقديم
                                                    بعد تنفيذ تحسينات على التقييمات.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                    </div>
                      <div class="q-pa-sm q-mb-xl" :data-box="9">
                        <h3 class="title">
                            صلاحية الاعتماد
                        </h3>
                        <ul class="content-list">
                                <li>يبقى الاعتماد ساريًا طالما التزم المقيم بمعايير الجودة.</li>
                                <li>يحق لإدارة النظام سحب الاعتماد أو تعليقه في الحالات التالية:
                                    <ul class="content-list nested">
                                        <li>تدني جودة التقييمات.</li>
                                        <li>تكرار الأخطاء أو المخالفات.</li>
                                        <li>الإخلال بشروط الاستخدام أو السرية.</li>
                                    </ul>
                                </li>
                            </ul>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="10">
                        <h3 class="title">
                            ملاحظات إضافية
                        </h3>
                        <ul class="content-list">
                                <li>لا يتم تنفيذ أي تحويل مالي إلا بعد اعتماد بيانات الحساب البنكي ومطابقتها مع اسم
                                    الهوية.</li>
                                <li>يتحمل المقيم مسؤولية دقة البيانات المقدمة.</li>
                                <li>تحتفظ الإدارة بحق تعديل شروط الاعتماد حسب الحاجة.</li>
                            </ul>
                    </div>
                     <div class="q-pa-sm q-mb-xl" :data-box="11">
                        <h3 class="title">
                            الخصوصية والسرية
                        </h3>
                        <ul class="content-list">
                                <li>تُخزّن البيانات بشكل مشفر.</li>
                                <li>لا تُعرض التقييمات أو هوية المقيمين لطرف ثالث.</li>
                                <li>يخضع المقيم والمراجع لاتفاقية عدم الإفصاح (NDA).</li>
                                <li>يتم تحديد صلاحيات الوصول بدقة داخل النظام.</li>
                            </ul>
                    </div>
                    <div class="q-pa-sm q-mb-xl" :data-box="12">
                        <h3 class="title">
                            تحديث المنهجية
                        </h3>
                        <ul class="content-list">
                            <li>يتم مراجعة هذه المنهجية بشكل دوري.</li>
                            <li>تعديلات المنهجية تعتمد من إدارة النظام.</li>
                            <li>يُحتفظ بسجل للإصدارات مع تاريخ كل إصدار.</li>
                        </ul>
                    </div> 
                   
                </div>
            </div>
        </div>
    </q-no-ssr>
</template>

<script setup lang="ts">
import { ref, nextTick } from 'vue';

const boxShow = ref(1);


const changeBox = async (box: number) => {
    boxShow.value = box;

    await nextTick();

    const targetBox = document.querySelector(`[data-box="${box}"]`);
    if (targetBox) {
        const elementPosition = targetBox.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 100;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
}
</script>

<style scoped lang="scss">
.box-type-helpers {

    border: 1px solid #ddd;

    @media (min-width: 768px) {
        position: sticky;
        top: 98px;
        max-height: calc(100vh - 98px);
        overflow-y: auto;
    }

    >div {
        position: relative;
        padding-inline: 16px;
        margin-block: 16px;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 4px;
            height: 100%;
            background-color: #5854FF;
            opacity: 0;
            transition: .2s;
        }

        &:hover::before,
        &.active::before {
            opacity: 1;
        }
    }
}

.box-content-helpers {
    border: 1px solid #ddd;
    border-radius: 8px;
    min-height: 100vh;
}

.title {
    font-size: var(--fs-5);
    font-weight: 500;
    margin-block: 16px;
}

.desc {
    font-size: var(--fs-md);
    color: #848C93;
    max-width: 520px;
}

.container-img {
    border-radius: 12px;
    border: 2px solid #ddd;
    padding: 20px;
    margin-block: 20px;

    >img {
        border-radius: 12px;
        width: 100%;
    }
}

.title {
    font-size: var(--fs-5);
    font-weight: 500;
    margin-block: 16px;
}

.desc {
    font-size: var(--fs-md);
    color: #333;
    max-width: 700px;
}

.methodology-table {
    width: 100%;
    max-width: 700px;
    border: 1px solid #eee;
    border-radius: 12px;
    overflow: hidden;

    .table-header,
    .table-row {
     
        font-size: var(--fs-md);
        font-weight: 500;
        display: flex;
        justify-content: space-around;
        align-items: center;
        gap: 1px;

        >div {
            width: 100%;
            text-align: center;
            padding: 10px;
        }
    }

    .table-header {
        color: #fff;

        >div {
            background-color: #5854FF;

        }
    }

    .table-row {
        >div:first-of-type {
            color: #5854FF;
        }
        &.alt-bg {
            background-color: #eee;
        }
    }
}

.lifecycle-list {
    padding-inline-start: 20px;
    margin-top: 32px;
    margin-bottom: 20px;
    max-width: 700px;

    >li {
        margin-block: 16px;
        line-height: 1.6;
        font-size: var(--fs-md);
        color: #333;

        >strong {
            font-weight: 500;
        }

        >ul {
            margin-top: 8px;
            padding-inline-start: 20px;
            margin-block: 8px;

            >li {
                margin-block: 6px;
                color: #555;
                line-height: 1.6;
            }
        }
    }
}

.subtitle {
    font-size: var(--fs-6);
    font-weight: 500;
    margin-top: 32px;
    margin-bottom: 16px;
}

.subtitle-small {
    font-size: var(--fs-md);
    font-weight: 500;
    margin-top: 24px;
    margin-bottom: 12px;
}

.content-list {
    margin-block: 16px;
    padding-inline-start: 20px;
    max-width: 700px;

    &.numbered {
        list-style-type: decimal;
        padding-inline-start: 24px;
    }

    >li {
        margin-block: 12px;
        line-height: 1.7;
        font-size: var(--fs-md);
        color: #333;

        >strong {
            font-weight: 500;
        }
    }

    &.nested {
        margin-top: 8px;
        margin-bottom: 8px;
        padding-inline-start: 20px;

        >li {
            margin-block: 6px;
            color: #555;
            font-size: 0.95em;
        }
    }
}


</style>
